var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 49.5,
    fill: "#ED2975",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8188 35.4066C27.65 34.1319 28.6418 33 29.9277 33L41.5508 33C42.1231 33 42.6712 33.2306 43.0714 33.6397L44.809 35.4159C45.2092 35.825 45.7574 36.0556 46.3296 36.0556H80.0484C81.3426 36.0556 82.3369 37.2014 82.1545 38.4826L76.9313 75.1725C76.7821 76.221 75.8843 77 74.8253 77H35.1929C34.126 77 33.2241 76.2097 33.084 75.1521L27.8188 35.4066Z",
    fill: "#ED2975"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4641 46.4222C26.285 45.1425 27.2787 44 28.5708 44H81.4291C82.7213 44 83.715 45.1425 83.5359 46.4222L79.5115 75.1677C79.3644 76.2183 78.4657 77 77.4048 77H32.5952C31.5343 77 30.6356 76.2183 30.4885 75.1677L26.4641 46.4222Z",
    fill: "#FF72A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5681 61.4821C57.3181 61.4821 57.1154 61.6848 57.1154 61.9349V66.9223C57.1154 67.1723 56.9127 67.375 56.6627 67.375H53.3373C53.0873 67.375 52.8846 67.1723 52.8846 66.9223V61.9349C52.8846 61.6848 52.6819 61.4821 52.4319 61.4821H50.3695C50.0033 61.4821 49.7886 61.0699 49.9986 60.7698L54.6291 54.1548C54.8093 53.8974 55.1907 53.8974 55.3709 54.1548L60.0014 60.7698C60.2114 61.0699 59.9967 61.4821 59.6305 61.4821H57.5681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.6e73f4f3cb8eb10bab8a4d733df172ef.svg";
export { ForwardRef as ReactComponent };